export const FacetIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="11.5547"
        y1="0.618164"
        x2="11.5547"
        y2="21.0675"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <line
        x1="11.5566"
        y1="0.883789"
        x2="11.5566"
        y2="21.3331"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <line
        x1="21.5313"
        y1="11.3584"
        x2="1.08196"
        y2="11.3584"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default FacetIcon;